export { default } from './ExternalLogout';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/ExternalLogout/index.js